import { Provider } from '@angular/core';

/**
 * services
 */
import { UploadsApiService } from '../api';
import { UploadsFacadeService } from '../facade';
import { UPLOADS_API } from './uploads-api.token';

/**
 * Registers the two uploads layers, the HTTP one and the facade, and
 * exposes the HTTP one only through its token.
 *
 * It returns plain providers and not environment ones on purpose, so it
 * can be declared on the component showing the batches. The list state
 * then lives and dies with that screen, and no other part of the app can
 * reach the uploads service without asking for it.
 *
 * @returns The providers to add.
 *
 * @example
 * ```typescript
 * providers: [
 * ...provideUploads(),
 * ],
 * ```
 */
export const provideUploads = (): Provider[] => {

    return [
        UploadsApiService,
        {
            provide: UPLOADS_API,
            useExisting: UploadsApiService,
        },
        UploadsFacadeService,
    ];
};
